module.exports = __webpack_public_path__ + "static/media/money.86ade16e.svg";